import { getStandardColumns } from '@townsquare/columns/hooks/use-shown-columns';
import { createRelayResource, RelayResourceConfig } from '@townsquare/relay-utils';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
} from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';

import DirectoryViewTeamQuery, {
	type DirectoryViewTeamQuery as DirectoryViewTeamQueryType,
} from '../components/__generated__/DirectoryViewTeamQuery.graphql';

import {
	appendEmptyTeamSearchToTql,
	getTeamColumnsToFetchInTql,
	updateTeamQueryBasedOnScreen,
} from './utils';

export const getTeamDirectoryTableResourceQuery = (
	routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<DirectoryViewTeamQueryType> => {
	const context = resourceContext as HomeResourceContext;
	const selectedStandardColumns = getStandardColumns('teams', routerContext.query.columns);

	const user = context.user;
	const baseTeamQuery = routerContext.query.tql || '';
	const teamQuery = appendEmptyTeamSearchToTql(
		updateTeamQueryBasedOnScreen(baseTeamQuery, routerContext.query.screen, user),
	);

	return {
		query: DirectoryViewTeamQuery,
		variables: {
			teamQuery: teamQuery,
			organisationId: context.workspace?.organisationId ?? context.orgId ?? '',
			cloudId: (context.collabContext?.rovoWorkspace || context.workspace?.cloudId) ?? 'None',
			...getTeamColumnsToFetchInTql(selectedStandardColumns),
		},
		options: {
			fetchPolicy: 'store-and-network',
		},
	};
};

export const teamDirectoryTableResource = createRelayResource<DirectoryViewTeamQueryType>({
	getQuery: getTeamDirectoryTableResourceQuery,
});
